import { render, staticRenderFns } from "./subMenu.vue?vue&type=template&id=028d616a&scoped=true&"
import script from "./subMenu.vue?vue&type=script&lang=ts&"
export * from "./subMenu.vue?vue&type=script&lang=ts&"
import style0 from "./subMenu.vue?vue&type=style&index=0&id=028d616a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028d616a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AntModal: require('/var/lib/jenkins/workspace/e-world-nuxt/components/antModal.vue').default})
